<template>
  <b-card>
    <b-card-title>
      <h3>Dispatch History</h3>
    </b-card-title>
    <base-overlay :show="tripInfoLoading.dispatch">
      <b-table
        v-if="dispatchesList"
        :fields="tableColumns"
        :items="dispatchesList"
        responsive
        striped
        bordered
        show-empty
        empty-text="No dispatches found"
        class="text-center"
      >
        <template
          #cell(messages)="row"
        >
          <b-form-checkbox
            v-if="row.item.dispatch_messages.length"
            v-model="row.detailsShowing"
            @change="row.toggleDetails"
          >
            <span class="message_style">{{ row.detailsShowing ? 'Hide' : 'Show' }} Messages</span>
          </b-form-checkbox>
          <span v-else>No messages to be shown</span>

        </template>
        <template
          #row-details="row"
        >
          <dispatch-messages
            :dispatches="row.item.dispatch_messages"
            :cycle-number="row.item.cycle_number"
          />
        </template>
      </b-table>
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BTable, BFormCheckbox,
} from 'bootstrap-vue'
import { watch, ref, inject } from '@vue/composition-api'
import formatDate from '@/utils/date-format'
import DispatchMessages from './DispatchMessages.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import driversStore from '@/views/driver/driverStoreModule'

export default {
  components: {
    BCard,
    BCardTitle,
    BTable,
    DispatchMessages,
    BFormCheckbox,
  },
  props: {
    dispatches: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const tripInfoLoading = inject('tripInfoLoading')

    const dispatchesList = ref(null)
    useRegisterStoreModule('drivers', driversStore)
    const tableColumns = [

      {
        key: 'messages',
        label: '',
      },
      {
        key: 'cycle_number',
        label: 'cycle number',
      },
      {
        key: 'unit',
        label: 'unit',
      },
      {
        key: 'radius',
        label: 'radius',
      },
      {
        key: 'created_at',
        label: 'created at',
        formatter: val => formatDate(val),
      },

    ]
    watch(() => props.dispatches, value => {
      if (value) {
        dispatchesList.value = value.map(disp => ({
          ...disp,
          ...disp.options,
        }))
      }
    })

    return {
      tableColumns,
      dispatchesList,
      tripInfoLoading,
    }
  },

}
</script>

<style scoped>
.message_style{
    margin-left: -30px
}
</style>
